<template>
  <div class="wj_box">
    <div class="wj_header">
      <el-row>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 22, offset: 1 }"
          :md="{ span: 16, offset: 4 }"
          :lg="{ span: 14, offset: 5 }"
          :xl="{ span: 14, offset: 5 }"
          class="wj_header_main"
        >
          <div class="wj_header_left">
            <img
              alt="投票、企业投票云服务、企业投票、网络投票、微信投票、会议投票"
              src="../../../assets/images/logo2_1.png"
            />
          </div>
          <a @click="userOut()">
            <i class="el-icon-switch-button"></i>
            <span>退出</span>
          </a>
        </el-col>
      </el-row>
    </div>
    <el-row class="wj_main">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <el-table
          :data="meetingQuestionnaireInfo.QuestionnaireItems"
          style="width: 100%"
          :show-header="false"
          empty-text="暂无问卷"
        >
          <el-table-column>
            <template slot-scope="scope">
              <div class="wj_item">
                <div
                  class="wj_item_title"
                  v-html="scope.row.QuestionnaireName"
                ></div>
                <div class="wj_item_num">
                  <span>
                    <i class="iconfont icon-daibiaodahui"></i>
                    {{ scope.row.AnswerUserTitle }}：
                    <span class="wj_item_num_count"
                      >{{ scope.row.UsersNumber }}
                    </span>
                  </span>
                  <span>
                    <i class="el-icon-menu"></i>
                    {{ scope.row.QuestinsTitle }}：
                    <span class="wj_item_num_count">
                      {{ scope.row.QuestinsNumber }}
                    </span>
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.IsLimitTime && scope.row.StartTime">
                开始时间：
                {{ scope.row.StartTime | dateformat('YYYY.MM.DD HH:mm') }}
              </span>
              <span v-if="scope.row.IsLimitTime && scope.row.TimeDuration">
                答题限时：
                {{ scope.row.TimeDuration }}
                分钟
              </span>
            </template>
          </el-table-column>
          <el-table-column width="80">
            <template slot-scope="scope">
              <span
                v-if="
                  (scope.row.RoleId === 0 || scope.row.RoleId === 1) &&
                  scope.row.IsSubmit
                "
              >
                已提交
              </span>
              <span
                v-if="
                  (scope.row.RoleId === 0 || scope.row.RoleId === 1) &&
                  !scope.row.IsSubmit
                "
              >
                未提交
              </span>
              <span v-if="scope.row.RoleId === 7 && scope.row.State === 1">
                进行中
              </span>
              <span v-if="scope.row.RoleId === 7 && scope.row.State === 2">
                已结束
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="openAnswerPaper(scope.row)"
                v-if="
                  (scope.row.RoleId === 0 || scope.row.RoleId === 1) &&
                  !scope.row.IsSubmit
                "
              >
                开始答卷
              </el-button>
              <el-button
                type="primary"
                size="mini"
                @click="openCompleteAnswerPaper(scope.row)"
                v-if="
                  (scope.row.RoleId === 0 || scope.row.RoleId === 1) &&
                  scope.row.IsSubmit
                "
              >
                查看答卷
              </el-button>
              <el-button
                type="primary"
                size="mini"
                @click="openMarkingAnswerPaperList(scope.row)"
                v-if="scope.row.RoleId === 7"
              >
                阅卷
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="wj_footer">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <div>北京鹏宇成软件技术有限公司 提供技术支持</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import answerPaperApi from '../../../api/wj/answerPaper'
export default {
  data () {
    return {
      meetingQuestionnaireInfo: []
    }
  },
  methods: {
    userOut: function () {
      this.$confirm('确定退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'wj_message_box'
      }).then(() => {
        this.$store.commit('REMOVE_ACCOUNT')
        this.$router.push({ name: 'answerLogin', params: { cid: this.meetingQuestionnaireInfo.CompanyID, mid: this.$route.params.mid, qid: 0 } })
      }).catch(() => {

      })
    },
    getMeetingQuestionnaireInfo: function () {
      const _this = this
      _this.openLoading()
      answerPaperApi.getMeetingQuestionnaireInfo({
        meetingID: _this.$route.params.mid
      }).then(data => {
        _this.meetingQuestionnaireInfo = data
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    openAnswerPaper: function (item) {
      this.$router.push({ name: 'answerPaper', params: { cid: this.meetingQuestionnaireInfo.CompanyID, mid: this.$route.params.mid, qid: item.QuestionnaireId, aid: item.AnswerPaperId, s: 'list' } })
    },
    openCompleteAnswerPaper: function (item) {
      this.$router.push({ name: 'completeAnswerPaper', params: { cid: this.meetingQuestionnaireInfo.CompanyID, mid: this.$route.params.mid, qid: item.QuestionnaireId, aid: item.AnswerPaperId, s: 'list' } })
    },
    openMarkingAnswerPaperList: function (item) {
      this.$router.push({ name: 'markingAnswerPaperList', params: { cid: this.meetingQuestionnaireInfo.CompanyID, mid: this.$route.params.mid, qid: item.QuestionnaireId, s: 'list' } })
    }
  },
  created () {
    this.getMeetingQuestionnaireInfo()
  }
}
</script>

<style lang="less">
@import '../../../assets/css/wj.css';
</style>
